import React from 'react';

import './FieldValueVerticalCell.scss';

export default class FieldValueSignUpVerticalCell extends React.Component {
    render() {
        return (
            <div {...this.props} render="">
                <p className="field-value-cell-signup-header">{this.props.title}</p>
                {this.props.render &&
                    this.props.render()
                }
                {!this.props.render &&
                    <>
                        <span className={this.props.fieldclass}>{this.props.value || "-"}
                            {this.props.currency &&  (
                                <span> {this.props.currency}</span>
                            )}
                        </span>

                        {this.props.hint && (
                            <div className="field-value-cell-hint">{this.props.hint}</div>
                        )}
                    </>
                }
            </div>
        )
    }

}
